export const ReportType = {
  REPORT4D: '4D',
  REPORT8D: '8D',
};

export const D3Status = [
  {
    value: 'Nyitott',
    label: 'Nyitott',
  },
  {
    value: 'Folyamatban',
    label: 'Folyamatban',
  },
  {
    value: 'Kész',
    label: 'Kész',
  },
];
